<template lang="html">
  <div class="group-container">
    <div class="group-title">
      <span>{{ title }}</span>
      <span>{{ score }}/{{ questionsNumber }}</span>
    </div>
    <div class="group-questions">
      <div class="group-question-box"
        v-for="(question, index) in questions" :key="index"
        :class="{'answer-wrong': !isQuestionCorrectAnswer(question), 'selected': selectedQuestion && selectedQuestion.id === question.id}"
        @click="selectQuestion(question)"
      >
        <span class="group-question-box-number">{{ index + 1 }}</span>
      </div>
    </div>
    <Question v-if="selectedQuestion" :question="selectedQuestion"/>
  </div>
</template>

<script>
import Question from './Question.vue'

export default {
  name: 'response-tabs-tab-test-group',

  components: {
    Question
  },

  props: {
    group: Object
  },

  data () {
    return {
      questions: [],
      selectedQuestion: null
    }
  },

  computed: {
    title () {
      return this.group.title
    },

    score () {
      return this.group.score
    },

    questionsNumber () {
      return this.questions ? this.questions.length : 0
    }
  },

  methods: {
    isQuestionCorrectAnswer (question) {
      if (Array.isArray(question.answers)) {
        return Boolean(question.answers.find(answer => answer.is_chosen === true && answer.is_valid === true))
      }

      return false
    },

    selectQuestion (question) {
      if (this.selectedQuestion && this.selectedQuestion.id === question.id) {
        this.selectedQuestion = null
      } else {
        this.selectedQuestion = question
      }
    }
  },

  beforeMount () {
    // just copy array so that we can sort it with out error about changind store state out of mutation
    this.questions = this.group.questions.map(item => item)
    this.questions.sort((q1, q2) => q1.priority - q2.priority)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/variables.scss';

.group-container {
  padding: 24px 0px;
  border-bottom: 1px solid #c4c4c4;
  max-width: 568px;

  .group-title {
    font-size: 16px;
    font-weight: bold;
  }

  .group-questions {
    margin-top: 17px;

    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .group-question-box {
      box-sizing: border-box;
      width: 10%;
      height: 40px;
      border: 1px solid #e5e5e5;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      color: $green;

      & + .group-question-box {
        border-left: none;
      }

      &.answer-wrong {
        color: $red-color;
      }

      &.selected {
        background-color: #f2f2f2;
      }
    }
  }
}
</style>
